<template>
  <!--//@*/*
      //    *BCS   App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <timeout
    :seconds_to_final="60"
    v-bind:loginURL="loginURL"
    v-if="showtimeout"
  ></timeout>
</template>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import timeout from "./timeout";
export default {
  name: "auth",
  mixins: [bus_common],
  components: { timeout },
  data() {
    return {
      x: "auth this",
      refreshTimer: null,
      showtimeout: false,
      role: "ew-canlogin",
      custom_target: ".v-main",
      background_color: "#363c43",
      button_color: "#00b88a",
      //  loginURL: 'https://rpdportal.org/?returnURL=http://localhost:44365/'
      loginURL: "https://rpdportal.org",
    };
  },
  mounted() {
    let callback = () => {
      window.location.replace(self.loginURL);
    };
    this.showtimeout = true;
    var self = this;
    this.refreshTimer = window.setTimeout(() => {
      if (
        self.$store.state.user != undefined &&
        self.$store.state.user.auth == true
      ) {
        var form = { token: self.$store.state.user.token };

        this.$store
          .dispatch("valtoken", form)
          .then((data) => {
            //console.log("Valid");
            var user = {
              email: data.email,
              date: this.$moment(data.date),
              auth: true,
              token: form.token,
              roles: data.roles,
              rpduserId: data.rpduserId,
              local_roleId: data.local_roleId,
            };

            if (data.roles.indexOf(self.role) == -1) {
              this.$swal({
                title: "Roles!",
                text: "You do not have the needed role for this app, you will be redirected to a login page.",
                icon: "warning",
                confirmButtonText: "OK",
                background: this.background_color,
                confirmButtonColor: this.button_color,
                target: this.custom_target,
                position: "center",
                timer: 3000,
                didClose: callback,
              });
            }

            this.$store.commit("setUser", user);
            this.$store.dispatch("checkAdminRole", null);
            this.$store.dispatch("checkAddRole", null);
            this.$store.dispatch("checkEditRole", null);
            this.$store.dispatch("checkNWRole", null);
          })
          .catch((error) => {
            if (error.response) {
              self.show_loader(false);
              this.$swal({
                title: "Login Error!",
                text: "You have not logged in or your login has timed out, you will be redirected to the login page.",
                icon: "warning",
                confirmButtonText: "OK",
                background: this.background_color,
                confirmButtonColor: this.button_color,
                target: this.custom_target,
                position: "center",
                timer: 3000,
                didClose: callback,
              });
            }
          });
      }
    }, 300000);
    //Check token evey 5m
  },
  created() {
    let callback = () => {
      window.location.replace(self.loginURL);
    };
    var qry_token = this.$route.query.token;
    var user_token = this.$store.state.user.token;
    var self = this;

    if (qry_token == undefined && user_token == "") {
      var self = this;
      self.show_loader(false);
      this.$swal({
        title: "Login Error!",
        text: "You have not logged in or your login has timed out, you will be redirected to the login page.",
        icon: "warning",
        confirmButtonText: "OK",
        background: this.background_color,
        confirmButtonColor: this.button_color,
        target: this.custom_target,
        position: "center",
        timer: 3000,
        didClose: callback,
      });
    } else {
      //validate toke, query takes precendent
      var token = qry_token != undefined ? qry_token : user_token;

      var form = {
        token: token,
      };

      var self = this;
      /*                this.$axios.post('api/valtoken', form)*/
      this.$store
        .dispatch("valtoken", form)
        .then((data) => {
          //console.log("valid");
          var user = {
            email: data.email,
            date: this.$moment(data.date),
            auth: true,
            token: form.token,
            roles: data.roles,
            rpduserId: data.rpduserId,
            local_roleId: data.local_roleId,
          };
          if (user.email == null) {
            self.show_loader(false);
            this.$swal({
              title: "Login Error!",
              text: "You have not logged in or your login has timed out, you will be redirected to the login page.",
              icon: "warning",
              confirmButtonText: "OK",
              background: this.background_color,
              confirmButtonColor: this.button_color,
              target: this.custom_target,
              position: "center",
              timer: 3000,
              didClose: callback,
            });
          }

          if (data.roles.indexOf(self.role) == -1) {
            this.$swal({
              title: "Roles!",
              text: "You do not have the needed role for this app, you will be redirected to a login page.",
              icon: "warning",
              confirmButtonText: "OK",
              background: this.background_color,
              confirmButtonColor: this.button_color,
              target: this.custom_target,
              position: "center",
              timer: 3000,
              didClose: callback,
            });
          }
          this.$store.commit("setUser", user);
          this.$store.dispatch("checkAdminRole", null);
          this.$store.dispatch("checkAddRole", null);
          this.$store.dispatch("checkEditRole", null);
          this.$store.dispatch("checkNWRole", null);
        })
        .catch((error) => {
          if (error.response) {
            self.show_loader(false);
            this.$swal({
              title: "Login Error!",
              text: "You have not logged in or your login has timed out, you will be redirected to the login page.",
              icon: "warning",
              confirmButtonText: "OK",
              background: this.background_color,
              confirmButtonColor: this.button_color,
              target: this.custom_target,
              position: "center",
              timer: 3000,
              didClose: callback,
            });
          }
        });
    }
  },
};
</script>
